import React from 'react';
import { Alert, Typography } from 'antd';
import { grpc } from '@improbable-eng/grpc-web';

const { Paragraph } = Typography;

interface ErrorExplainProps {
  messageList: string[];
  codeList: number[];
}

class ErrorExplain extends React.PureComponent<ErrorExplainProps> {
  getCorrectExplanations = (code: number): string => {
    switch (code) {
      case grpc.Code.InvalidArgument:
        return 'Innsend skrá er ekki á réttu sniði.';
      case grpc.Code.DeadlineExceeded:
        return 'Vinnsla tók of langan tíma. Mögulegar útskýringar get verið: Myndband eða hljóðskrá of stór, lélegt samband netþjóna eða hæg nettenging.';
      case grpc.Code.Internal:
        return 'Villa hefur átt sér stað í bakenda eða á netþjón. Vinsamlegast reynið aftur. Ef villan kemur aftur, vinsamlegast hafið samband.';
      default:
        return '';
    }
  };

  render() {
    const descriptionContent = this.props.messageList.map((item, index) => (
      <div key={item}>
        <Paragraph strong>{item}</Paragraph>
        <Paragraph style={{ paddingLeft: '1em' }}>
          - {this.getCorrectExplanations(this.props.codeList[index])}
        </Paragraph>
      </div>
    ));

    if (descriptionContent.length === 0) {
      return null;
    }

    return <Alert type='error' message='Hvað þýða villu skilaboðin?' description={<div>{descriptionContent}</div>} />;
  }
}

export default ErrorExplain;
